import { render } from "./AreaIcon.vue?vue&type=template&id=c201212a&scoped=true"
import script from "./AreaIcon.vue?vue&type=script&lang=js"
export * from "./AreaIcon.vue?vue&type=script&lang=js"

import "./AreaIcon.vue?vue&type=style&index=0&id=c201212a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c201212a"]])

export default __exports__